import * as React from 'react';
import { Create } from 'react-admin';
import { JobForm } from './commons';
import { transformRecord } from './utils';

const JobCreate = () => (
    <Create transform={transformRecord}>
        <JobForm />
    </Create>
);

export default JobCreate;
